import { render } from "./ElementType.vue?vue&type=template&id=62bcdf25"
import script from "./ElementType.vue?vue&type=script&lang=js"
export * from "./ElementType.vue?vue&type=script&lang=js"

import "./ElementType.vue?vue&type=style&index=0&id=62bcdf25&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__